import { BaseAPI } from './base';

export interface ReportExportProgress {
  done: number;
  total: number;
}

export interface ReportExportSummary {
  counts?: Record<string, number>;
  exported?: number;
  [key: string]: any;
}

export interface ReportExportStatus {
  status: 'pending' | 'running' | 'completed' | 'failed' | 'cancelled';
  progress?: ReportExportProgress;
  summary?: ReportExportSummary;
  error?: string;
}

class ReportExportsAPI extends BaseAPI {
  async startDayExport(payload: {
    date: string;
    doctor_id: string;
    physician_match?: string;
  }): Promise<{ task_id: string }> {
    return this.request<{ task_id: string }>({
      method: 'POST',
      url: '/api/v1/report-exports/day',
      data: payload,
    });
  }

  async getExportStatus(taskId: string): Promise<ReportExportStatus> {
    return this.request<ReportExportStatus>({
      method: 'GET',
      url: `/api/v1/report-exports/status/${taskId}`,
    });
  }

  async downloadExportZip(taskId: string): Promise<Blob> {
    return this.requestRaw({
      method: 'GET',
      url: `/api/v1/report-exports/download/${taskId}`,
      responseType: 'blob',
      timeout: 300000,
    });
  }

  async sendExportEmail(
    taskId: string,
    payload: { email_to: string; message?: string }
  ): Promise<{ sent: boolean; delivery?: 'link' | 'attachment' }> {
    return this.request<{ sent: boolean; delivery?: 'link' | 'attachment' }>({
      method: 'POST',
      url: `/api/v1/report-exports/email/${taskId}`,
      data: payload,
      timeout: 180000,
    });
  }

  async cancelExport(taskId: string): Promise<{ cancelled: boolean }> {
    return this.request<{ cancelled: boolean }>({
      method: 'POST',
      url: `/api/v1/report-exports/cancel/${taskId}`,
    });
  }
}

export const reportExportsAPI = new ReportExportsAPI();
export default reportExportsAPI;
